var module = angular.module('octopusApp.projects');

module.controller("TargetSettingsDialogController", function($scope, $injector, pluginRegistry, projectId, $uibModalInstance, $q, busy, octopusRepository) {
  var isLoading = $scope.isLoading = busy.create();
  var isPreviewing = $scope.isPreviewing = busy.create();
  var isSaving = $scope.isSaving = busy.create();

  var promises = [
    octopusRepository.MachineRoles.all().then(function (machineRoles) { $scope.availableRoles = machineRoles; }),
    octopusRepository.Projects.get(projectId).then(function (project) {
      $scope.project = project;
    })
  ];

  isLoading.promise($q.all(promises));

  $scope.accept = function() {
    isSaving.promise(octopusRepository.Projects.modify($scope.project).then(function (p) {
      $uibModalInstance.close(true);
    }));
  };
  $scope.close = function() {
    $uibModalInstance.close();
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/controllers/project_target_settings_dialog_controller.js
// module id = 528
// module chunks = 1